import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { BNPLApi } from '@frontend/api-buy-now-pay-later';
import { http } from '@frontend/fetch';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useAlert } from '@frontend/design-system';

export type BuyNowPayLaterPortalProps = {
  locationId: string | undefined;
};
export const BuyNowPayLaterPortal = ({ locationId }: BuyNowPayLaterPortalProps) => {
  const { t } = useTranslation('payments');
  const alert = useAlert();
  const [portalLink, setPortalLink] = useState('');

  const getPortalLink = async () => {
    try {
      const {
        links: { embedPortalUrl },
      } = await BNPLApi.buyNowPayLater.getPortal(locationId ?? '');
      setPortalLink(embedPortalUrl);
    } catch (err) {
      if (http.isHttpError(err)) {
        if (err.status === 422) {
          alert.error(t('Sunbit could not find your location. Try again or contact support.'));
        } else {
          alert.error(t('There was a problem loading the portal.'));
        }
      }
    }
  };

  useEffect(() => {
    getPortalLink();
  }, []);

  return (
    <div
      css={css`
        margin-top: ${theme.spacing(6)};
        padding-top: 100%;
        position: relative;
        width: 100%;
      `}
    >
      <iframe
        id='BNPLEmbeddedPortal'
        title={t('Sunbit Embedded Portal')}
        src={portalLink}
        style={{
          border: '0px',
          borderRadius: `${theme.spacing(1)}`,
          boxShadow: `${theme.shadows.heavy}`,
          position: 'absolute',
          top: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};
